// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'megaphone';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M5.04 11.448H3.384C1.8 11.448.576 10.224.576 8.64c0-1.584 1.224-2.808 2.808-2.808H5.04z' />
    <path d='M5.04 11.448c3.312 0 6.552 1.008 9.288 2.808l.864.576V2.448l-.864.576c-2.736 1.8-5.976 2.808-9.288 2.808zm12.384-3.96V9.72M5.04 11.448c0 1.512.576 2.88 1.656 3.96' />
  </g>
);

export const viewBox = '0 0 18 18';
